import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-registration-disabled',
    templateUrl: './registration-disabled.component.html',
    styleUrls: ['./registration-disabled.component.scss']
})
export class RegistrationDisabledComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
